/* 8bitbrain · iOS-style notification badge.
   Markup: snippets/notif-badge.liquid ([data-nb], text-free: the count is CSS from data-n),
   badge styles: sections/header.liquid,
   "What's new" pill + NEW tags + #whats-new: sections/applefx-updates.liquid.
   Honest by design: the count is the number of NEW items in the latest AppleFX release
   (sections/applefx-updates.liquid).
   It never goes away on its own (scrolling past the release notes does not clear it). A visitor
   clears it only with a tap: the badged AppleFX link (header pill, mobile menu link, AppleFX
   product card) or the floating "What's new" pill ([data-nb-float]). That lasts for the current
   browser session only (sessionStorage, per version key from Theme settings > Notification badge),
   so the badge is back on the next visit. The floating "What's new" pill itself always stays
   available on the AppleFX page. */
(function () {
  'use strict';
  if (window.__bbNB) return;
  window.__bbNB = 1;

  var KEY = 'bbNotifSeenS';
  /* up to v7 the badge cleared for good (localStorage 'bbNotifSeen') as soon as the release notes
     scrolled into view: drop that old flag so those visitors get the badge back */
  try { localStorage.removeItem('bbNotifSeen'); } catch (e) {}

  var mq = function (q) { try { return window.matchMedia(q).matches; } catch (e) { return false; } };
  var RM = mq('(prefers-reduced-motion: reduce)');
  var DESIGN = !!(window.Shopify && window.Shopify.designMode);
  var V = '', seen = false, started = false;
  var io = null, pill = null;

  function all(sel, root) { return [].slice.call((root || document).querySelectorAll(sel)); }
  function readSeen() { try { return sessionStorage.getItem(KEY) || ''; } catch (e) { return ''; } }
  function writeSeen(v) { if (DESIGN || !v) return; try { sessionStorage.setItem(KEY, v); } catch (e) {} }
  /* the version key of the badges on this page, and whether this session already tapped it away */
  function initVer() {
    if (V) return true;
    var first = document.querySelector('[data-nb]');
    if (!first) return false;
    V = first.getAttribute('data-nb-v') || 'afx';
    seen = !DESIGN && readSeen() === V;
    return true;
  }

  /* ---------- helpers ---------- */
  function popover() { return document.getElementById('mobile-popover'); }
  /* main.js opens the menu with visibility:visible + opacity:1 and, on close, drops opacity at once
     but keeps visibility:visible for the 300ms fade, so both have to be checked */
  function menuOpen() { var p = popover(); return !!(p && p.style.visibility === 'visible' && p.style.opacity !== '0'); }
  function inMenu(b) { var p = popover(); return !!(p && p.contains(b)); }
  function inFloat(b) { return !!(b.closest && b.closest('[data-nb-float]')); }
  function onScreen(el) {
    if (!el || !el.getBoundingClientRect) return false;
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0 && r.bottom > 0 && r.right > 0 &&
      r.top < (window.innerHeight || 800) && r.left < (window.innerWidth || 400);
  }
  function hostOf(b) { return b.parentElement || b; }
  /* the link / button a badge belongs to: its ancestor (menu link, burger, floating pill) or,
     for the desktop nav pill where the badge sits on the <li> next to the link, that sibling link */
  function ownerOf(b) {
    if (b.__nbOwner !== undefined) return b.__nbOwner;
    var o = b.closest ? b.closest('a,button') : null;
    /* only a direct sibling counts, so a badge in a card image never describes an unrelated button */
    if (!o && b.parentElement) {
      [].some.call(b.parentElement.children, function (c) {
        if (c !== b && c.matches && c.matches('a[href],button')) { o = c; return true; }
        return false;
      });
    }
    b.__nbOwner = o || null;
    return b.__nbOwner;
  }
  /* the badge has no text of its own (clean anchor text), so screen readers get "4 new"
     as the owner's description, and only while the badge is actually showing */
  function describe(b, on) {
    var o = ownerOf(b);
    if (!o) return;
    var t = b.getAttribute('data-nb-label');
    if (on && t) o.setAttribute('aria-description', t);
    else o.removeAttribute('aria-description');
  }

  /* ---------- pop in / pop out ---------- */
  function popIn(b, delay) {
    if (seen || b.__nbOn) return;
    b.__nbOn = 1;
    clearTimeout(b.__nbT);
    b.__nbT = setTimeout(function () {
      b.classList.remove('nb-out');
      /* desync the idle wiggle so several badges never jiggle in lockstep */
      b.style.setProperty('--nb-wd', (1.4 + Math.random() * 2.6).toFixed(2) + 's');
      b.classList.add('nb-on');
      describe(b, true);
    }, delay || 0);
  }
  function popOut(b, delay) {
    if (!b.__nbOn) return;
    b.__nbOn = 0;
    clearTimeout(b.__nbT);
    b.__nbT = setTimeout(function () {
      var had = b.classList.contains('nb-on');
      b.classList.remove('nb-on');
      describe(b, false);
      if (!had || RM) return;
      b.classList.add('nb-out');
      b.__nbT = setTimeout(function () { b.classList.remove('nb-out'); }, 620);
    }, delay || 0);
  }
  function drop(b) {
    b.__nbOn = 0;
    clearTimeout(b.__nbT);
    b.classList.remove('nb-on', 'nb-out');
    describe(b, false);
  }
  function repop(b, delay) { drop(b); popIn(b, delay); }

  /* ---------- badged links (AppleFX header pill + menu link) ---------- */
  function swapLinks(on) {
    all('[data-nb-href]').forEach(function (a) {
      if (on) {
        if (!a.hasAttribute('data-nb-orig')) a.setAttribute('data-nb-orig', a.getAttribute('href') || '');
        a.setAttribute('href', a.getAttribute('data-nb-href'));
      } else if (a.hasAttribute('data-nb-orig')) {
        a.setAttribute('href', a.getAttribute('data-nb-orig'));
      }
    });
  }

  /* ---------- scrolling to the release notes ---------- */
  function newsTarget() { return document.querySelector('[data-nb-watch]') || document.getElementById('whats-new'); }
  function headerBottom() {
    var n = document.querySelector('.pill-nav-container') || document.querySelector('.header-stack');
    if (!n) return 80;
    var r = n.getBoundingClientRect();
    return Math.max(0, Math.min(r.bottom, 170));
  }
  function goNews(instant) {
    var t = newsTarget();
    if (!t) return false;
    var r = t.getBoundingClientRect(), vh = window.innerHeight || 800, hb = headerBottom();
    var free = vh - hb;
    var off = r.height < free ? hb + Math.max(16, (free - r.height) / 2.6) : hb + 16;
    var y = Math.max(0, Math.round(r.top + (window.pageYOffset || document.documentElement.scrollTop || 0) - off));
    var L = window.__bbLenis;
    if (L && typeof L.scrollTo === 'function') {
      L.scrollTo(y, { immediate: !!instant || RM, duration: 1.1 });
    } else {
      try { window.scrollTo({ top: y, behavior: (instant || RM) ? 'instant' : 'smooth' }); }
      catch (e) { window.scrollTo(0, y); }
    }
    return true;
  }

  /* ---------- the visitor tapped the badge away (this browser session only) ---------- */
  function markSeen() {
    if (seen) return;
    seen = true;
    writeSeen(V);
    swapLinks(false);
    var k = 0;
    all('[data-nb]').forEach(function (b) {
      if (!b.__nbOn) return;
      /* the floating pill stays; only its badge goes */
      if (inFloat(b)) { if (pill && pill.classList.contains('is-shown')) popOut(b, 0); else drop(b); return; }
      if (inMenu(b)) { if (menuOpen()) popOut(b, 90 * k++); else drop(b); return; }
      var host = hostOf(b);
      if (onScreen(host)) { popOut(b, 90 * k++); return; }
      var r = host.getBoundingClientRect();
      if (!r.width && !r.height) drop(b);
      /* otherwise it stays up and pops out when scrolled into view (see the observer) */
    });
  }

  /* ---------- pop-in when the badge scrolls into view ---------- */
  function observe(b) {
    if (b.__nbSeenBy) return;
    b.__nbSeenBy = 1;
    if (inMenu(b) || inFloat(b)) return; /* handled by the menu / the pill */
    var host = hostOf(b);
    var delay = b.classList.contains('nb--card') ? 520 : 140;
    if (!io) {
      if (onScreen(host)) popIn(b, delay);
      return;
    }
    host.__nb = b;
    io.observe(host);
  }
  function makeIO() {
    if (!('IntersectionObserver' in window)) return null;
    return new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var b = en.target.__nb;
        if (!b || !en.isIntersecting) return;
        var delay = b.classList.contains('nb--card') ? 520 : 140;
        if (!seen) popIn(b, delay);
        else if (b.__nbOn) popOut(b, 650); /* tapped away elsewhere: let the visitor watch it go */
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.35 });
  }

  /* ---------- mobile menu: re-pop the badge every time the menu opens ---------- */
  function initMenu() {
    var burger = document.getElementById('mobile-burger');
    if (!burger || burger.__nbMenu) return;
    burger.__nbMenu = 1;
    burger.addEventListener('click', function () {
      setTimeout(function () {
        var p = popover();
        if (!p) return;
        all('[data-nb]', p).forEach(function (b) {
          if (menuOpen() && !seen) repop(b, 200);
          else if (!menuOpen()) drop(b);
        });
      }, 30);
    });
  }

  /* ---------- floating "What's new" pill (AppleFX page): always available ---------- */
  function initPill() {
    var p = document.querySelector('[data-nb-float]');
    if (!p || p.__nbPill) return;
    p.__nbPill = 1;
    pill = p;
    var badge = p.querySelector('[data-nb]');
    var zone = document.getElementById('whats-new') || newsTarget();
    var sticky = document.getElementById('afxhSticky');
    var ticking = false;

    /* ride above the AppleFX sticky buy bar while it is up (its real height, safe-area padding included) */
    function syncSticky() {
      var up = !!(sticky && sticky.classList.contains('show'));
      if (up) {
        var h = sticky.getBoundingClientRect().height;
        if (h > 0) p.style.setProperty('--nb-up', Math.round(h + 12) + 'px');
      }
      p.classList.toggle('is-up', up);
    }
    /* shown once the visitor has scrolled a screen down and is away from the release notes */
    function update() {
      ticking = false;
      var vh = window.innerHeight || 800;
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      var nearNews = false;
      if (zone) {
        var r = zone.getBoundingClientRect();
        nearNews = r.top < vh * 0.9 && r.bottom > vh * 0.15;
      }
      var want = y > vh * 0.9 && !nearNews;
      if (want && !p.classList.contains('is-shown')) {
        syncSticky();
        p.classList.add('is-shown');
        if (badge && !seen) repop(badge, 260);
      } else if (!want && p.classList.contains('is-shown')) {
        p.classList.remove('is-shown');
      }
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }

    if (sticky && 'MutationObserver' in window) {
      new MutationObserver(syncSticky).observe(sticky, { attributes: true, attributeFilter: ['class'] });
    }
    syncSticky();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);

    p.addEventListener('click', function () {
      initVer();
      if (badge) popOut(badge, 0);
      if (!seen) writeSeen(V);
      p.classList.add('is-tapped');
      goNews(false);
      setTimeout(function () { markSeen(); p.classList.remove('is-tapped'); }, 300);
    });
    update();
  }

  /* ---------- deep link /products/applefx#whats-new ---------- */
  function initHash() {
    if (!/^#whats-new$/i.test(location.hash || '') || !newsTarget()) return;
    var moved = false;
    function mark() { moved = true; }
    ['wheel', 'touchstart', 'keydown'].forEach(function (ev) {
      window.addEventListener(ev, mark, { passive: true, once: true });
    });
    afterLoader(function () { if (!moved) goNews(true); });
    /* images above the notes can shift the native jump (Safari has no scroll anchoring) */
    window.addEventListener('load', function () { setTimeout(function () { if (!moved) goNews(true); }, 150); });
  }

  /* ---------- a tap on the badge clears it for this session ----------
     Counts as a tap: the badged AppleFX link (header pill / menu link, [data-nb-href]) and a link on the
     AppleFX product card (the card carrying the badge). The burger only opens the menu, where the badge
     pops in again on the AppleFX link; the floating pill has its own handler (initPill). */
  function badgedTap(o) {
    if (!o || o.id === 'mobile-burger' || o.hasAttribute('data-nb-float')) return false;
    if (o.hasAttribute('data-nb-href')) return true;
    if (!o.matches('a[href]')) return false;
    if (o.querySelector('[data-nb]')) return true;
    var card = o.closest('.v9-pc,.product-card');
    return !!(card && card.querySelector('[data-nb]'));
  }
  /* capture phase: runs before the page-transition handler and any link script */
  document.addEventListener('click', function (e) {
    if (e.button !== 0) return;
    var o = e.target && e.target.closest ? e.target.closest('a[href],button') : null;
    if (!badgedTap(o) || !initVer()) return;
    /* same-page badged link (/products/applefx#whats-new on the AppleFX page): scroll instead of reloading */
    if (!e.defaultPrevented && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey && o.hasAttribute('data-nb-href')) {
      var url = null;
      try { url = new URL(o.getAttribute('href') || '', location.href); } catch (err) { url = null; }
      if (url && url.hash && url.origin === location.origin && url.pathname === location.pathname && newsTarget()) {
        e.preventDefault();
        if (menuOpen()) { var burger = document.getElementById('mobile-burger'); if (burger) burger.click(); }
        goNews(false);
      }
    }
    if (seen) return;
    writeSeen(V);
    /* after this click, so the link still follows the badged href (Theme settings > Notification badge > Link) */
    setTimeout(markSeen, 0);
  }, true);

  /* ---------- wait for the brand loader (first desktop view only) ---------- */
  function loaderUp() {
    var el = document.getElementById('bb-loader');
    if (!el || !el.isConnected || el.classList.contains('bb-ld-hide')) return false;
    var cs = window.getComputedStyle(el);
    return cs.display !== 'none' && cs.visibility !== 'hidden' && parseFloat(cs.opacity) > 0.05;
  }
  function afterLoader(cb) {
    var fired = false;
    function go(d) { if (fired) return; fired = true; setTimeout(cb, d); }
    if (!loaderUp()) { go(180); return; }
    var t = setInterval(function () { if (!loaderUp()) { clearInterval(t); go(320); } }, 120);
    setTimeout(function () { clearInterval(t); go(0); }, 5000);
  }

  /* ---------- boot ---------- */
  function scan() {
    if (!initVer()) return;
    if (!seen) swapLinks(true);
    initMenu();
    initPill();
    if (seen) return;
    if (!io) io = makeIO();
    all('[data-nb]').forEach(observe);
  }
  function boot() {
    if (started) return;
    started = true;
    initHash();
    afterLoader(scan);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function () { setTimeout(scan, 60); });
  /* Back/forward cache (iOS swipe back): the restored page may still show the badge although the
     visitor tapped it away on another page of this visit. Re-read the session state. */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted || seen || !V || DESIGN) return;
    if (readSeen() === V) markSeen();
  });
})();
